import React, { useState, useEffect, Fragment, useContext } from 'react';
import Traductor from '../Traductor';
import { VehiclesContext } from '../../contexts/VehiclesContext';
import {
    formatYear,
    formatDate,
    formatNumber,
    checkCountDownStatus,
    getReceptorVehicleLocation,
} from '../../js/components/shared/vehicleFunctions';
import { withCookies } from 'react-cookie';
import '../../css/components/shared/vehicleCard/VehicleCard.css';
import Carousel from '../bronson/Carousel';
import {
    getImageSource,
    isAppleDeviceOrNavegatorForDates,
} from '../../Functions';

import EngineIcon from '../../images/icons/engine-icon.png';
import MedalIcon from '../../images/icons/medal-icon.png';
import VehicleDealerReceptorTags from './VehicleDealerReceptorTags';
import ModalDetailVehicle from 'components/auctions/ModalDetailVehicle';
import Footer from 'components/auctions/AuctionVehicleCard/Footer';

function VehicledealerReceptorCard({
    history,
    vehicleParent,
    serverTime,
    fetchServerTime,
}) {
    const t = new Traductor();
    const { setSelectedVehicle, selectedVehicle } = useContext(VehiclesContext);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const cardId = 'card-vehicle-' + (vehicleParent ? vehicleParent.Id : '');
    const [showDetail, setShowDetail] = useState(false);

    const [vehicleStatus, setVehicleStatus] = useState(
        checkCountDownStatus(
            isAppleDeviceOrNavegatorForDates(vehicleParent.StartDate),
            isAppleDeviceOrNavegatorForDates(vehicleParent.EndDate),
            serverTime
        )
    );

    useEffect(() => {
        window.addEventListener('resize', getWindowWitdh);
    }, []);

    useEffect(() => {
        checkRightContainerWidth();
    }, [windowWidth]);

    const getWindowWitdh = () => {
        setWindowWidth(window.innerWidth);
    };

    const checkRightContainerWidth = () => {
        let card = document.querySelector(
            '#' + cardId + ' .c-vehicle-card__right-information'
        );
        let rightContainerWidth = '';
        if (card) {
            rightContainerWidth = card.parentElement.offsetWidth - 4;
            document.querySelector(
                '#' + cardId + ' .c-vehicle-card__right-information'
            ).style.width = rightContainerWidth + 'px';
        }
    };

    const printCardHeader = () => {
        if (windowWidth > 720) {
            return (
                <div className="o-layout">
                    <div className="o-layout__item u-1/1 u-p-none u-m-none">
                        <div className="c-vehicle-card__header-left-container">
                            {getImagesList()}
                        </div>
                        <div className="c-vehicle-card__header-right-container">
                            <div className="o-layout">
                                <VehicleDealerReceptorTags
                                    vehicle={vehicleParent}
                                    floating={false}
                                    vehicleStatus={vehicleStatus}
                                    changeVehicleStatus={changeVehicleStatus}
                                    serverTime={serverTime}
                                ></VehicleDealerReceptorTags>
                                <div className="o-layout__item u-1/1 u-p-none u-m-none">
                                    <p
                                        className="c-card__title"
                                        onClick={() => {
                                            setShowDetail(true);
                                            setSelectedVehicle(vehicleParent);
                                        }}
                                    >
                                        {vehicleParent.Plate
                                            ? vehicleParent.Plate
                                            : null}
                                        <span>
                                            {vehicleParent.Brand
                                                ? ' - ' +
                                                  vehicleParent.Brand
                                                      .Description
                                                : null}
                                            {vehicleParent.Model
                                                ? ' ' +
                                                  vehicleParent.Model
                                                      .DescriptionLong
                                                : null}
                                        </span>
                                    </p>
                                </div>
                                <div className="o-layout__item u-1/1 u-p-none u-mb-none">
                                    {printVehicleDetails()}
                                </div>
                            </div>
                        </div>
                        {windowWidth < 1440
                            ? printFloatingInformation('tablet')
                            : null}
                    </div>
                </div>
            );
        } else {
            return (
                <Fragment>
                    <div
                        className="o-layout"
                        onClick={() => {
                            setShowDetail(true);
                            setSelectedVehicle(vehicleParent);
                        }}
                    >
                        <div className="o-layout__item u-1/1 u-pl-none">
                            <p className="c-card__title">
                                {vehicleParent.Plate
                                    ? vehicleParent.Plate
                                    : null}
                                <span>
                                    {vehicleParent.Brand
                                        ? ' - ' +
                                          vehicleParent.Brand.Description
                                        : null}
                                    {vehicleParent.Model
                                        ? ' ' +
                                          vehicleParent.Model.DescriptionLong
                                        : null}
                                </span>
                            </p>
                        </div>
                        <div className="o-layout__item u-1/1 u-p-none u-mb-none">
                            {printVehicleDetails()}
                        </div>
                    </div>
                    {printFloatingInformation('mobile')}
                </Fragment>
            );
        }
    };

    const printVehicleDetails = () => {
        return (
            <p className="u-m-none">
                {vehicleParent.RegistrationDate
                    ? formatYear(vehicleParent.RegistrationDate)
                    : null}
                {vehicleParent.Kms
                    ? ' | ' + formatNumber(vehicleParent.Kms) + ' Km'
                    : null}
                {vehicleParent.CV ? ' | ' + vehicleParent.CV + ' CV' : null}
                {vehicleParent.Energy ? ' | ' + vehicleParent.Energy : null}
                {vehicleParent.VIN ? ' | ' + vehicleParent.VIN : null}
            </p>
        );
    };

    const getImagesList = (typeList = false) => {
        if (typeList) return [getImageSource(vehicleParent.ImageSource)];
        return (
            <img
                src={getImageSource(vehicleParent.ImageSource)}
                onClick={() => {
                    setShowDetail(true);
                    setSelectedVehicle(vehicleParent);
                }}
                alt="vehicle"
            />
        );
    };

    const printCardImageMobileVersion = () => {
        if (windowWidth > 720) return null;

        let optionsCarousel = {
            id: 'c-vehicle-card__carousel-' + vehicleParent.Id,
            next: true,
            images: getImagesList(true),
            flickity: {
                imagesLoaded: false,
            },
        };

        return (
            <div
                className="c-vehicle-card__carousel-container"
                onClick={() => {
                    setShowDetail(true);
                    setSelectedVehicle(vehicleParent);
                }}
            >
                <Carousel
                    options={optionsCarousel}
                    onClickFunction={() => {
                        setShowDetail(true);
                        setSelectedVehicle(vehicleParent);
                    }}
                />
                <VehicleDealerReceptorTags
                    vehicle={vehicleParent}
                    floating={true}
                    vehicleStatus={vehicleStatus}
                    changeVehicleStatus={changeVehicleStatus}
                    serverTime={serverTime}
                ></VehicleDealerReceptorTags>
            </div>
        );
    };

    const printVehicleOptions = isMobile => {
        let component = (
            <Footer
                history={history}
                vehicle={vehicleParent}
                disabledVehicleWebSalesButtons={false}
                countDownStatus={vehicleStatus}
                setLoading={() => null}
                loading={false}
                disableButtons={() => false}
                updateVehiclesList={() => null}
                type={''}
            />
        );

        if (windowWidth > 720 && !isMobile) {
            return (
                <div className="o-layout__item u-3/12 u-2/6@l u-hide@s">
                    <div className="c-vehicle-card__right-information u-1/3">
                        {component}
                    </div>
                </div>
            );
        } else if (windowWidth < 720 && isMobile) {
            return (
                <footer className="c-card__footer u-p-none">
                    <hr />
                    <div className="u-p">{component}</div>
                </footer>
            );
        }
    };

    const printFloatingInformation = type => {
        //Cambiar Ids
        let vendibleEngine = vehicleParent.Engine ? true : false;

        if (vehicleParent.EndDateWarrantyExtension || vendibleEngine) {
            let warrantyItems = null;
            if (vehicleParent.EndDateWarrantyExtension) {
                warrantyItems = (
                    <Fragment>
                        <div className="o-inline-group__item">
                            <img
                                src={vehicleParent.skeleton ? null : MedalIcon}
                            ></img>
                        </div>
                        <div className="o-inline-group__item u-ml-small">
                            <p>{t.getTraduction('CurrentWarranty')}</p>
                        </div>
                    </Fragment>
                );
            }

            let engineItems = null;
            if (vehicleParent.Engine && vehicleParent.Engine.Description) {
                engineItems = (
                    <Fragment>
                        <div className="o-inline-group__item">
                            <img
                                src={vehicleParent.skeleton ? null : EngineIcon}
                            ></img>
                        </div>
                        <div className="o-inline-group__item u-ml-small">
                            <p className="c-vehicle-card--dealerReceptor__engine">
                                {vehicleParent.Engine.Description}
                            </p>
                        </div>
                    </Fragment>
                );
            }

            if (!warrantyItems && !engineItems) return null;

            if (windowWidth >= 1440 && type == 'desktop') {
                return (
                    <div className="c-vehicle-card--dealerReceptor__floating-info">
                        {warrantyItems != '' ? (
                            <div className="o-inline-group">
                                {warrantyItems}
                            </div>
                        ) : null}
                        {vendibleEngine != '' ? (
                            <div className="o-inline-group">{engineItems}</div>
                        ) : null}
                    </div>
                );
            } else if (
                windowWidth < 1440 &&
                windowWidth >= 720 &&
                type == 'tablet'
            ) {
                return (
                    <div className="o-layout">
                        <div className="o-layout__item u-1/1 u-pt-small">
                            <div className="o-inline-group">
                                {warrantyItems}
                                {engineItems}
                            </div>
                        </div>
                    </div>
                );
            } else if (windowWidth < 720 && type == 'mobile') {
                return (
                    <div className="o-layout">
                        {warrantyItems != '' ? (
                            <div className="o-layout__item u-1/1 u-1/2@s u-pt-small">
                                <div className="o-inline-group">
                                    {warrantyItems}
                                </div>
                            </div>
                        ) : null}
                        {vendibleEngine ? (
                            <div className="o-layout__item u-1/1 u-1/2@s u-pt-small">
                                <div className="o-inline-group">
                                    {engineItems}
                                </div>
                            </div>
                        ) : null}
                    </div>
                );
            }
        }
    };

    const changeVehicleStatus = () => {
        setVehicleStatus(state => state + 1);
    };

    return (
        <>
            <article
                id={cardId}
                key={cardId}
                className={
                    'c-card c-card--image c-vehicle-card c-vehicle-card--dealerReceptor u-text-left u-pb@s ' +
                    (vehicleParent.skeleton ? 'c-vehicle-card--skeleton' : '')
                }
            >
                {printCardImageMobileVersion()}
                <header className="c-card__header">{printCardHeader()}</header>
                <div className="c-card__body u-pl-small@xxl u-pl-small@xl u-pl-small@l u-pl-small@m u-pl-none@s u-pl-none@xs u-pr-none u-pt-none u-pb-small">
                    <div className="o-layout u-p-none@s">
                        {windowWidth < 720 ? <hr /> : null}
                        <div className="o-layout__item u-9/12 u-4/6@l u-1/1@s">
                            <div className="o-layout">
                                <div className="o-layout__item u-1/4 u-1/2@l">
                                    <p className="u-text-disabled u-mb-xsmall">
                                        {t.getTraduction('FinancialOperation')}
                                    </p>
                                    <p>
                                        {vehicleParent.FinancialOperation
                                            ? vehicleParent.FinancialOperation
                                            : '--'}
                                    </p>
                                </div>
                                <div className="o-layout__item u-1/4 u-1/2@l">
                                    <p className="u-text-disabled u-mb-xsmall">
                                        {t.getTraduction(
                                            'PurchaseOptionStartEnd'
                                        )}
                                    </p>
                                    <p>
                                        {vehicleParent.StartDate
                                            ? formatDate(
                                                  new Date(
                                                      isAppleDeviceOrNavegatorForDates(
                                                          vehicleParent.StartDate
                                                      )
                                                  )
                                              )
                                            : ''}{' '}
                                        -{' '}
                                        {vehicleParent.EndDate
                                            ? formatDate(vehicleParent.EndDate)
                                            : ''}
                                    </p>
                                </div>
                                <div className="o-layout__item u-1/4 u-1/2@l">
                                    <p className="u-text-disabled u-mb-xsmall">
                                        {t.getTraduction('ReturnDealer')}
                                    </p>
                                    <p>
                                        {vehicleParent.DealerReturn
                                            ? vehicleParent.DealerReturn
                                                  .Description
                                            : '--'}
                                    </p>
                                </div>
                                <div className="o-layout__item u-1/4 u-1/2@l">
                                    <p className="u-text-disabled u-mb-xsmall">
                                        {t.getTraduction('Location')}
                                    </p>
                                    <p>
                                        {getReceptorVehicleLocation(
                                            vehicleParent
                                        )}
                                    </p>
                                    {printFloatingInformation('desktop')}
                                </div>
                            </div>
                        </div>
                        {printVehicleOptions(false)}
                    </div>
                </div>
                {printVehicleOptions(true)}
            </article>
            {showDetail && selectedVehicle?.Id === vehicleParent?.Id ? (
                <ModalDetailVehicle
                    vehicle={selectedVehicle}
                    onShowDetail={status => {
                        setShowDetail(status);
                        setSelectedVehicle(status);
                    }}
                    printCountDown={() => (
                        <VehicleDealerReceptorTags
                            vehicle={selectedVehicle}
                            floating={false}
                            vehicleStatus={vehicleStatus}
                            changeVehicleStatus={changeVehicleStatus}
                            viewType="detail"
                            serverTime={serverTime}
                        />
                    )}
                    printFavouriteIcon={() => null}
                    printWebSalesOptions={() => (
                        <Footer
                            vehicle={selectedVehicle}
                            disabledVehicleWebSalesButtons={false}
                            countDownStatus={vehicleStatus}
                            setLoading={() => null}
                            loading={false}
                            disableButtons={() => false}
                            updateVehiclesList={setSelectedVehicle}
                            type={'detailvehicle'}
                        />
                    )}
                    updateVehiclesList={setSelectedVehicle}
                    tagMaxBidStatus={() => null}
                    fetchServerTime={fetchServerTime}
                    inactive={false}
                />
            ) : null}
        </>
    );
}

export default withCookies(VehicledealerReceptorCard);
